<template>
  <div class="loading-overlay">
    <div class="loading-overlay-inner">
      Loading
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-overlay'
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  position: fixed;
  width: 100%;
  z-index: 1;

  .loading-overlay-inner {
    color: #000;
    font-size: 28px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
</style>
